import { accuracy } from './data/accuracy';
import { relevance } from './data/relevance';
import { toxicity } from './data/toxicity';

export const judgeTemplateRegistry = {
  accuracy,
  relevance,
  toxicity,
} as const;

export const judgeTemplateListItems = Object.values(judgeTemplateRegistry);

export type JudgeTemplateRegistry = typeof judgeTemplateRegistry;
export type JudgeTemplateKey = keyof JudgeTemplateRegistry;
